import { render, staticRenderFns } from "./weiList.vue?vue&type=template&id=e2c4b642&scoped=true"
import script from "./weiList.vue?vue&type=script&lang=js"
export * from "./weiList.vue?vue&type=script&lang=js"
import style0 from "./weiList.vue?vue&type=style&index=0&id=e2c4b642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4b642",
  null
  
)

export default component.exports